module.exports = __webpack_public_path__ + "img/9.d93f2125.png";